<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>新闻管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.newstype" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in newstypeList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.title" @keyup.enter.native="clicksearch" placeholder="请输入新闻标题" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="编号" min-width="5%"></el-table-column>
          <el-table-column prop="Newstypes" label="新闻类型" min-width="15%"></el-table-column>
          <el-table-column prop="Title" label="新闻标题" min-width="10%"></el-table-column>
          <el-table-column prop="Info" label="新闻简介" min-width="20%"></el-table-column>
          <el-table-column prop="Fromname" label="来源名称" min-width="10%"></el-table-column>
          <el-table-column prop="Parentid" label="父新闻编号" min-width="8%"></el-table-column>
          <el-table-column prop="Ishots" label="是否热点" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goPic(scope.row)">缩略图</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="新闻类型">
            <el-select v-model="addData.newstype" placeholder="请选择" class="select">
              <el-option
                v-for="item in newstypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新闻标题" class="addAdminForm">
            <el-input v-model="addData.title" placeholder="请输入新闻标题"></el-input>
          </el-form-item>
          <el-form-item label="新闻简介" class="addAdminForm">
            <el-input v-model="addData.info" type="textarea" :rows="5" placeholder="请输入新闻简介"></el-input>
          </el-form-item>
          <el-form-item label="来源图标" class="addAdminForm">
            <el-input v-model="addData.fromlogo" placeholder="请输入来源图标"></el-input>
          </el-form-item>
          <el-form-item label="来源名称" class="addAdminForm">
            <el-input v-model="addData.fromname" placeholder="请输入来源名称"></el-input>
          </el-form-item>
          <el-form-item label="详细内容">
            <VueUeditorWrap v-model="addData.content" :config="myConfig"></VueUeditorWrap>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteNewsEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteNewsEdit>
      </el-tab-pane>

      <el-tab-pane label="缩略图" name="three" disabled="disabled">
        <KgjtWebsiteNewsPic ref="SubVuethree" v-on:triggerFunc="BackToFirst"></KgjtWebsiteNewsPic>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteNewsEdit from '@/componentsKgjt/KgjtWebsiteNewsEdit.vue'
import KgjtWebsiteNewsPic from '@/componentsKgjt/KgjtWebsiteNewsPic.vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteNewsEdit,
    KgjtWebsiteNewsPic,
    VueUeditorWrap
  },
  name: 'MyKgjtWebsiteNews',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      newstypeList: [],
      // 查询客户
      keywords: {
        newstype: '0',
        title: ''
      },
      // 添加
      addData: {
        newstype: '',
        title: '',
        info: '',
        content: '',
        fromlogo: '',
        fromname: '睿世力控股集团'
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.addData.fromlogo = Vue.prototype.global.Gv_FromLogo
    this.addData.fromname = Vue.prototype.global.Gv_FromName
    this.newstypeList = Vue.prototype.FunGetNewsType()
    this.GetKgjtWebsiteNewsNum()
    this.GetKgjtWebsiteNewsList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteNewsList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteNewsList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteNewsNum()
      this.GetKgjtWebsiteNewsList()
    },
    clickadd () {
      this.AddKgjtWebsiteNews()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteNews(row)
      })
    },
    // 产品特点
    goPic (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    GetKgjtWebsiteNewsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        newstype: that.keywords.newstype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteNewsList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteNewsNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newstype: that.keywords.newstype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteNewsNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteNews: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newstype: that.addData.newstype,
        title: that.addData.title,
        info: that.addData.info,
        content: that.addData.content,
        fromlogo: that.addData.fromlogo,
        fromname: that.addData.fromname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteNews, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.newstype = ''
            that.addData.title = ''
            that.addData.info = ''
            that.addData.content = ''
            that.addData.fromlogo = Vue.prototype.global.Gv_FromLogo
            that.addData.fromname = Vue.prototype.global.Gv_FromName

            that.GetKgjtWebsiteNewsNum()
            that.GetKgjtWebsiteNewsList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteNews: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteNews, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteNewsNum()
          that.GetKgjtWebsiteNewsList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
